module.exports = __webpack_public_path__ + "img/zxkf.acd504b.png";